import styles from './async-message.module.css';

interface AsyncMessageProperties {
  readonly kind: 'loading' | 'empty' | 'error';
  readonly title: string;
  readonly message?: string;
  readonly onRetry?: () => void;
}

export function AsyncMessage({ kind, title, message, onRetry }: AsyncMessageProperties) {
  return (
    <section aria-live="polite" className={styles.message} data-kind={kind}>
      <h1>{title}</h1>
      {message === undefined ? null : <p>{message}</p>}
      {onRetry === undefined ? null : (
        <button className={styles.button} onClick={onRetry} type="button">
          Réessayer
        </button>
      )}
    </section>
  );
}
